import axios, { AxiosResponse } from 'axios';

import AddInstrumentVersionInput from 'modules/Global/models/AddInstrumentVersionInput';

export default function createAsync(apiUrl: string) {
  return function api<TResponse>(
    input: AddInstrumentVersionInput | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/instrument-versions`,
          method: 'POST',
          data: input,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
